<template>
  <!-- 区域筛选参会人组件开始 -->
  <div class="area-container mar-top-5">
    <van-tabs v-model="currentTab" class="bord-btm pad-btm-10 van-cascader__tabs van-tabs--line">
      <van-tab v-for="(tab,idx) in tabData"
               :key="tab.id"
               :title="tab.name"
               :name="`${tab.id}`">
        <div v-if="areaData[tab.id] && areaData[tab.id].length > 0" class="area-tab-container mar-top-10">
          <van-cell v-for="area in areaData[tab.id]"
                    :key="area.id" clickable>
            <template #title>
              <van-checkbox v-model="area.selected"
                            shape="square" icon-size="14px"
                            @change="(checked) => areaCheckboxToggle(checked, area)">
                <span>{{area.name}}</span>
              </van-checkbox>
            </template>
            <template #right-icon>
              <div v-show="area.hasChild" @click="handleNextArea(area, idx+1)" class="icon-container">
                <van-icon name="arrow" class="van-cell__right-icon" size="14"></van-icon>
              </div>
            </template>
          </van-cell>
        </div>
        <div v-else-if="loading" class="text-center mar-ver">
          <van-loading size="14px" vertical>加载中...</van-loading>
        </div>
        <empty-notice v-else :desc="'暂无内容'"></empty-notice>
      </van-tab>
    </van-tabs>
    <van-row gutter="20" class="mar-all">
      <van-col span="12">
        <van-button block size="small" @click="handleSubmit(true)">清除</van-button>
      </van-col>
      <van-col span="12">
        <van-button block size="small" type="primary" @click="handleSubmit()">确定</van-button>
      </van-col>
    </van-row>
  </div>
</template>

<script>
  import {checkRespCorrect} from "../../../tools/utils";
  import {meetingRoom, exclusiveRoom} from "../../../server";

  export default {
    props: {
      roomSrc: String,
      currentAreas: Array
    },
    data() {
      return {
        currentTab: '0',
        tabData: [{id: "0", name: "全部"}],
        areaData: {},
        loading: true,
        locationMap: {},
        selectedAreas: []
      };
    },
    watch: {
      'tabData.length'(val) {
        Promise.resolve().then(() => {  // tab变化后持续渲染
          this.currentTab = this.tabData[val - 1].id
        })
      },
    },
    created() {
      // 初始化区域数据
      this.initAreas((pIds) => {
        this.getLocations({}, () => {
          pIds && (this.tabData = this.tabData.concat(pIds.map(pid => this.locationMap[pid])));
          this.loading = false;
        })
      })
    },
    methods: {
      initAreas(cd = () => false) {
        this.selectedAreas = [];
        // console.log(this.currentAreas);
        if (this.currentAreas && this.currentAreas.length) {
          // 查询选中的区域组
          this.getLocations({lctIds: this.currentAreas}, (list) => {
            this.selectedAreas = list || [];
            const pIdArr = this.selectedAreas.map(l => l.parents || []);
            const pIds = pIdArr[pIdArr.length - 1];
            // console.log(pIds);
            if (pIds && pIds.length) {
              // 查询某区域下的所有区域
              this.getLocations({pid: pIds[0], fetchChild: true}, () => cd(pIds));
            } else {
              cd()
            }
          });
          return
        }
        cd()
      },
      getLocations({pid, fetchChild, lctIds} = {}, cd = () => false) {  // 调用区域接口
        if (!fetchChild && !lctIds && this.areaData.hasOwnProperty(pid || '0')) {
          cd(this.areaData[pid || '0'].length);
          return;
        }
        this.queryLocation({
          pid,
          fetchChild,
          lctIds
        }, (resp) => {
          if (checkRespCorrect(resp)) {
            // console.log(resp.list);
            const parentMap = {};
            const list = resp.list.map(e => {
              const lct = {...e, selected: this.selectedAreas.some(l => l.id === e.id)};
              if (fetchChild) {
                if (parentMap[lct.pid]) {
                  parentMap[lct.pid].push(lct)
                } else {
                  parentMap[lct.pid] = [lct]
                }
              }
              this.locationMap = {...this.locationMap, [lct.id]: lct};
              return lct
            });
            // console.log(parentMap)
            if (fetchChild) {
              this.areaData = {...parentMap, ...this.areaData};
              cd();
              return;
            }
            if (lctIds) {
              cd(list);
              return
            }
            this.areaData = {
              ...this.areaData,
              [pid || '0']: list
            };
          }
          cd(resp.list && resp.list.length)
        })
      },
      queryLocation(filter, rsv) {
        switch (this.roomSrc) {
          case "exclusive":
            return exclusiveRoom.queryExclusiveLocation(this, {
              queryFilter: filter
            }).then(({searchExclusiveLocation: resp = {}}) => {
              rsv(resp)
            }).catch(err => {
              rsv()
            });
          case "normal":
          default:
            return meetingRoom.queryLocation(this, {
              queryFilter: filter
            }).then(({searchLocation: resp = {}}) => {
              rsv(resp)
            }).catch(err => {
              rsv()
            });
        }
      },
      handleNextArea(area, plusIdx) { // 选取下一个区域
        this.getLocations({pid: area.id}, (len) => {
          if (len) {
            this.tabData.splice(plusIdx, this.tabData.length - plusIdx, area);
            Promise.resolve().then(() => {
              this.currentTab = this.tabData[this.tabData.length - 1].id
            })
          } else {
            area.hasChild = false
          }
        })
      },
      areaCheckboxToggle(selected = false, area = {}) {
        const existIdx = this.selectedAreas.findIndex(a => a.id === area.id);
        if (selected && !~existIdx) {
          this.selectedAreas.push(area);
        }
        if (!selected && ~existIdx) {
          this.selectedAreas.splice(existIdx, 1);
        }
      },
      handleSubmit(cancel) {
        if (cancel) {
          this.selectedAreas.forEach(e => this.setAreaChecked(e, false));
          this.selectedAreas = [];
          this.tabData.splice(1, this.tabData.length - 1);
          return
        }
        // console.log(this.selectedAreas);
        this.$emit('change', this.selectedAreas.map(e => e.id));  // 向父组件传递变化
      },
      setAreaChecked(e, checked = false) {
        if (this.areaData[e.pid]) {
          this.areaData[e.pid].some(area => {
            if (area.id === e.id) {
              area.selected = checked;
              return true
            }
          })
        }
      },
    }
  };
</script>

<style lang="less">
  .area-container {

    .area-tab-container {
      max-height: 230px;
      overflow: auto;

      .icon-container {
        line-height: 18px;
        height: 20px;
        min-width: 100px;
        text-align: right;

        .van-icon {
          line-height: 18px;
        }
      }
    }

    .van-empty {
      padding: 10px 0 !important;
      margin-top: 0 !important;
    }

    .van-tabs__wrap {
      padding: 0 10px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.07);
    }
  }
</style>
